import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CommonVaultSUbHeaderSubjectService {
  openMXDrawer: BehaviorSubject<boolean> = new BehaviorSubject(false);
  handleOpenMXDrawer(val: boolean) {
    if (val === true) {
      this.openMXDrawer.next(true);
    } else {
      this.openMXDrawer.next(false);
    }
  }
}
